export enum ActionType {
	setLeftId = 'ScenarioComparison.SelectLeftId',
	setRightId = 'ScenarioComparison.SelectRightId',
}

export interface ERPSelectActionLeft {
	type: ActionType.setLeftId;
	payload: string;
}

export interface ERPSelectActionRight {
	type: ActionType.setRightId;
	payload: string | null;
}

export type Action = ERPSelectActionLeft | ERPSelectActionRight;
